<bz-select appBringozIdGenerator="serviceStatusesSelectDropBtn"
           size="sm"
           [ariaLabel]="'Default Status' | translate"
           [options]="options()"
           [value]="group()"
           (valueChange)="onValueChange($event)">
</bz-select>
